export default "__VITE_ASSET__Cthv9pIx__"